import { isFromWPSClient, openWPSNewTab } from "@meitu/xdesign-widgets/dist/wps/utils/client";

export const windowOpen = (url: string) => {
  if (isFromWPSClient()) {
    return openWPSNewTab(url);
  }
  return window.open(url);
};